import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommonInput from '@src/new-components/Input/CommonInput';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { Box } from '@mui/material';
import apis from '@src/apis';
import SelectSearch from '@src/new-components/Select/SelectSearch';
import { StyledBankInfo } from './index.style';

const BankInfo = ({
  bankInfo,
  handleChangeText,
  errors,
  disabled,
  touched,
}) => {
  const { t } = useTranslation();
  const { bankName, accountNumber, accountOwner } = bankInfo || {};
  const [bankList, setBankList] = useState([]);

  const fetchBankList = async () => {
    const res = await apis.banks.getAllBanks();

    if (res?.data) {
      const list = res.data.map((item) => ({
        name: `${item.shortName} - ${item.name}`,
        value: `${item.shortName} - ${item.name}`,
        id: item.id,
      }));
      setBankList(list);
    }
  };

  useEffect(() => {
    fetchBankList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    handleChangeText(value)(name);
  };

  const handleChangeBankName = (option) => {
    handleChangeText(option.value)('bankName');
  };

  const renderLabelInput = (label) => (
    <Typography variant="body-14-medium" color={COLOR.darkGray}>
      {label}
    </Typography>
  );
  return (
    <StyledBankInfo>
      <Typography variant="body-16-medium" color={COLOR.darkGray}>
        {t('bankInfo')}
      </Typography>

      <SelectSearch
        name="bankName"
        value={bankName}
        disabled={disabled}
        onChange={handleChangeBankName}
        options={bankList}
        placeholder={
          <Typography variant="body-14-regular" color={COLOR.label2[48]}>
            {t('chooseBankName')}
          </Typography>
        }
        label={renderLabelInput(t('bankName'))}
        error={!!errors?.bankName && touched?.bankName}
        helperText={t(errors?.bankName)}
      />
      <Box className="bank-info-input">
        <CommonInput
          name="accountNumber"
          label={renderLabelInput(t('cardNumber'))}
          placeholder={t('bankAccountNumberPlaceholder')}
          value={accountNumber}
          disabled={disabled}
          onChange={handleChange}
          className="bank-info-input-item"
          error={!!errors?.accountNumber && touched?.accountNumber}
          helperText={t(errors?.accountNumber)}
        />
        <CommonInput
          name="accountOwner"
          label={renderLabelInput(t('accountOwner'))}
          placeholder={t('bankAccountOwnerPlaceholder')}
          value={accountOwner}
          disabled
          onChange={handleChange}
          className="bank-info-input-item"
          error={!!errors?.accountOwner && touched?.accountOwner}
          helperText={t(errors?.accountOwner)}
        />
      </Box>
    </StyledBankInfo>
  );
};

export default BankInfo;
